exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Tooltip__container{font:normal 10px Verdana;position:absolute;padding:5px 10px;border-radius:4px;background:#fff;border:1px solid #aaa;opacity:.7;white-space:nowrap;visibility:visible;transition:opacity .2s ease,visibility .2s ease}.Tooltip__hidden{opacity:0;visibility:hidden}", ""]);

// exports
exports.locals = {
	"container": "Tooltip__container",
	"hidden": "Tooltip__hidden"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"minimize":true,"localIdentName":"[name]__[local]"}!./client/components/Tooltip.css
// module id = 20
// module chunks = 0